import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, DatePicker, Checkbox, Empty, Divider, Space, Timeline, Steps, Affix, InputNumber } from 'antd';
import { DepartmentDto, HrmsEmployeeDetailsDto, PlantsDropDown } from '@gtpl/shared-models/masters';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import './hrms-employee-details-form.css';
import { EmployeeRolesEnum, EmpPrefixEnum } from '@gtpl/shared-models/common-models'
// import {HHrmsEmployeeDetailsGrid} from '@gtpl/pages/master/master-components/sales-person-grid'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { DepartmentService, HrmsEmpDetService, UnitcodeService } from '@gtpl/shared-services/masters';
import { QualificationsDto } from '@gtpl/shared-models/masters';
import { QualificationsService } from '@gtpl/shared-services/masters';
import { IdproofsTypeService } from '@gtpl/shared-services/masters';
import { IdProofsTypeDto } from '@gtpl/shared-models/masters';
import {DesignationDto} from '@gtpl/shared-models/hrms';
import { Link, useHistory } from "react-router-dom";
import TextArea from 'rc-textarea';
import moment from 'moment';
import form from 'antd/lib/form';
import { OperationService, QaQcOperationsService } from '@gtpl/shared-services/production'
import {DesignationService} from '@gtpl/shared-services/hrms';
import { OperationsDropDown, QaQcData, VarientIdRequest } from '@gtpl/shared-models/production-management';
import { Console } from 'console';
import {RolesService} from '@gtpl/shared-services/masters';
import { CreateUserDto, EmployeeDto, CreateUserDtoDefault } from '@gtpl/shared-models/gtpl';
/* eslint-disable-next-line */
const { Option } = Select;
const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 8,
  },
};


const tailLayout = {
  wrapperCol: {
    offset: 10,
    span: 10,
  },
};
export interface HrmsEmployeeDetailsFormProps {
  hrmsData: HrmsEmployeeDetailsDto;
  updateDetails: (hrms: HrmsEmployeeDetailsDto) => void;
  isUpdate: boolean;
  closeForm: () => void;
}

export function HrmsEmployeeDetailsForm(props: HrmsEmployeeDetailsFormProps) {

  const [empform] = Form.useForm();
  
  const service = new HrmsEmpDetService;
 
  const [departmentsData, setDepartmentsData] = useState<DepartmentDto[]>([]);
  const [qualificationData, setQualificationData] = useState<QualificationsDto[]>([]);
  // const [idproofsData, setIdproofsData] = useState<IdProofsTypeDto[]>([]);
  const [selectedDept, setSelectedDept] = useState<any>(undefined);
  const departmentService = new DepartmentService();
  const qualificationsService = new QualificationsService();
  // const idproofsTypeService=new IdproofsTypeService();
  const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const [permanentAddress, setPermanentAddress] = useState<boolean>(false);
  const unitsService = new UnitcodeService();
  const [current, setCurrent] = useState<any>();
  const [autoRefresh, setautoRefresh] = useState(1);
  const { RangePicker } = DatePicker;
  const {Step} = Steps
  const [salariedEmployeeVisible,setsalariedEmployeeVisible] = useState<boolean>(false); 
  const [transferType, setTransferType] = useState<string>(undefined);
  const [laboursEmployeeVisible,setlaboursEmployeeVisible] = useState<boolean>(false); 
  const [designationData, setDesignationData] = useState<DesignationDto[]>([]);
  const designationService = new DesignationService();
 

  
  useEffect(() => {
    console.log(props.hrmsData);
    if(props.hrmsData?.employeeId>0 && props.isUpdate){
      let value = props.hrmsData.employeeType;
      console.log(value);
      if(value === "Salaried Form"){
        setsalariedEmployeeVisible(true) 
       }
       else{  
         setsalariedEmployeeVisible(false)
       }
       if(value==="Labour Form")
       {
         setlaboursEmployeeVisible(true)
       }
       else{
         setlaboursEmployeeVisible(false)
       }
    }
    getAllDesignation();
  },[]);

  /**
   * 
   */
  const getAllDesignation = () => {
    designationService.getAllDesignation().then(res => {
      if(res.status){
        setDesignationData(res.data);
      }else {
        if(res.intlCode){
          setDesignationData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setDesignationData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  } 



  let createdUser = "";
  if (!props.isUpdate) {
    createdUser = localStorage.getItem("createdUser");
  }
  useEffect(() => {
    getAllActiveDepartment();
    getAllActiveQualification();
    // getAllActiveIdProof();
    getAllPlants();
  }, [])
  const getAllActiveDepartment = () => {
    departmentService.getAllActiveDepartment().then(res => {
      if (res.status) {
        setDepartmentsData(res.data);
      } else {
        if (res.intlCode) {
          setDepartmentsData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setDepartmentsData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  const getAllActiveQualification = () => {
    qualificationsService.getAllActiveQualification().then(res => {
      if (res.status) {
        setQualificationData(res.data);
      } else {
        if (res.intlCode) {
          setQualificationData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setQualificationData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }


  // const getAllActiveIdProof = () => {
  //   IdProofsService. getAllActiveIdProof().then(res => {
  //     if (res.status) {
  //     setIdproofsData(res.data);
  //     } else {
  //       if (res.intlCode) {
  //         setIdproofsData([]);
  //           AlertMessages.getErrorMessage(res.internalMessage);
  //       } else {
  //        AlertMessages.getErrorMessage(res.internalMessage);
  //       }
  //     }
  //   }).catch(err => {
  //   setIdproofsData([]);
  //     AlertMessages.getErrorMessage(err.message);
  //   })
  // }


  const getAllPlants = () => {

    unitsService.getAllPlants().then((res) => {
      if (res.status) {
        setPlantData(res.data);

      } else {
        // if (res.intlCode) {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // } else {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // }
        setPlantData([]);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setPlantData([]);
    })
  }
  const save = (hrmsData: HrmsEmployeeDetailsDto) => {
    console.log(hrmsData)
    console.log('submit clicked')
    service.create(hrmsData).then(res => {
      if (res.status) {
        AlertMessages.getSuccessMessage('Employee Details Created Successfully');
        history.push('/HRMS-employee_details-view')
        onReset();
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  let currentAdd;
  const setAddress = (val) => {
    if (val.target.checked) {
      console.log(val);
      console.log(form.getFieldsValue());
      console.log(form.getFieldValue('currentAddress'));
      currentAdd = form.getFieldValue("currentAddress");
      permanentAddress == false ? setPermanentAddress(false) : setPermanentAddress(true)
      if (permanentAddress == false) {
        console.log(permanentAddress)
        console.log('true---')
        form.setFieldsValue({
          permanentAddress: currentAdd
        })
      }
    } else {
      form.setFieldsValue({
        permanentAddress: null
      })
    }

  }
  const getAllOperations = () => {
    operationService.getAllOperationsDropDown().then(res => {
      if (res.status) {
        setOperations(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  

  const calculateExperience = () => {
    const a = moment(form.getFieldValue('fromDate'), '"YYYY-MM-DD')
    const b = moment(form.getFieldValue('toDate'), '"YYYY-MM-DD')
    var diffDays = (b.diff(a, 'days'));
    if (a && b) {
      console.log('days', diffDays, 'a', a, 'b', b)
      form.setFieldsValue({
        experience: diffDays
      })
    }
  }


  // useEffect(() => {
  //   getNoOfDays();

  // },[])



  // const getNoOfDays = () => {
  //   const a = moment(form.getFieldValue('fromDate'),'"YYYY-MM-DD');
  //   const b = moment(form.getFieldValue('toDate'),'"YYYY-MM-DD');
  //   var diffDays = b.diff(a, 'days');
  //   console.log('days')
  //   console.log(diffDays);
  //   form.setFieldsValue({
  //     noOfDays: diffDays 
  //   })



  // }
  const qaqcService = new QaQcOperationsService;

  const [form] = Form.useForm();
  const operationService = new OperationService
  const [selectedOperation, setSelectedOperation] = useState<number>(null);
  const [operations, setOperations] = useState<OperationsDropDown[]>([]);

  let history = useHistory();


  useEffect(() => {
    getAllOperations()
  }, [])



  const saveData = (values: HrmsEmployeeDetailsDto) => {
    console.log('va', values);
    if (props.isUpdate) {
      props.updateDetails(values);
    } else {
    save(values);
    }

  };
  const onReset = () => {
    form.resetFields();
  };
  const onClose = () => {
    props.closeForm;
  }

  function onChange(value) {
    console.log(`selected ${value}`);
  }

  function onSearch(val) {
    console.log('search:', val);
  }

  const familyDetailsAffix = () => {
    setCurrent(2)
  }

  const educationDetailsAffix = () => {
    setCurrent(3)
  }

  const jobDetailsAffix = () => {
    setCurrent(1)
   
  }

  const idProofDetailsAffix = () => {
    setCurrent(4)
  }

  const experienceDetailsAffix = () => {
    setCurrent(5)
  }

  // const experienceCalculation = (fromDateOriginal, toDateOriginal) => {
  //   console.log(fromDateOriginal?.format('YYYY MM DD'))
  //   console.log(toDateOriginal)
  //   const fromDate=fromDateOriginal?fromDateOriginal:moment();
  //   const toDate=toDateOriginal?toDateOriginal:moment();
  //   console.log(fromDate.format('YYYY MM DD'))
  //   console.log(toDate.format('YYYY MM DD'))
  //   const years = fromDate.diff(toDate, 'year');
  //   toDate.add(years, 'years');
  //   const months = fromDate.diff(toDate, 'months');
  //   toDate.add(months, 'months');
  //   const days = fromDate.diff(toDate, 'days');
  //   console.log(years + ' years ' + months + ' months ' + days + ' days')
  //   return years + ' years ' + months + ' months ' + days + ' days';
  // }
  
  const onFocus = () => {
    console.log('focus');
  }

  const onBlur = () => {
    console.log('blur');
  }

  const formType = (value) =>{
    setTransferType(value);
    if(value === "Salaried Form"){
     setsalariedEmployeeVisible(true) 
    }
    else{  
      setsalariedEmployeeVisible(false)
    }
    if(value==="Labour Form")
    {
      setlaboursEmployeeVisible(true)
    }
    else{
      setlaboursEmployeeVisible(false)
    }
  }
  // const HrmsGrid = new HrmsEmployeeDetailsGrid();

  return (

  
    <Card title={<span style={{color:'white'}}>Employees Form</span>}
        style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate==true?"":<Link to='/HRMS-employee_details-view' ><span style={{color:'white'}} ><Button className='panel_button' >View </Button> </span></Link>} >
    
    
        <Form form={form} 
        initialValues={props.hrmsData} 
        name="control-hooks" 
        onFinish={saveData}
          layout="vertical"
          > 
          <br/>
          {salariedEmployeeVisible ?<><Affix>
          
          <Card style={{width:'100%'}} headStyle={{width:'100%'}} >
          <Steps size="small" current={current}>
          <Step title="Personal Details" />
          <Step title="Job Details" />
          <Step title="Family Details" />
          <Step title="Educational Details" />
          <Step title="Id Proof Details" />
          <Step title="Experience Details" />
          <Step title="Finish" status='finish' />
      </Steps>
          </Card>
          </Affix></>:<></>}
          
        <br/><br/>
        <Col xs={{span:24}} sm={{span:24}} md={{span:5,offset:1}} lg={{span:5,offset:1}} xl={{span:5,offset:1}} style={{margin:'1%'}} >
          <Form.Item
              name="employeeType"
              label="Employee Type"
              rules={[
                {
                  required: true,
                  
                }
              ]}>
                {<Select
                onChange={formType}
                showSearch
                placeholder="Select Employee Type"
              >
                
                <Option key={1} value= {'Salaried Form'}>Salaried Employee</Option>
                <Option key={2} value= {'Labour Form'}>Labour Employee</Option>
            </Select> }
            </Form.Item>
        </Col>
       
        {salariedEmployeeVisible ?
          <><h1 style={{ color: 'grey', fontSize: '25px', textAlign: 'left' }}>Personal Details</h1>
          <Row gutter={24}>
                <Form.Item name="employeeId" style={{ display: "none" }}>
                  <Input hidden />
                </Form.Item>
                <Form.Item style={{ display: "none" }} name="createdUser" initialValue={createdUser}>
                  <Input hidden />
                </Form.Item>

                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="employeeCode"
                      label="Employee Code"
                      rules={[
                        {
                          required: true,
                          message: "Enter Employee code"
                        },
                        {
                          // pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z0-9 ]*$/,
                          pattern: /^[^-\s\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z0-9 ]*$/,
                          message: `Should contain only alphabets and numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="prefix"
                      label="Prefix"
                      rules={[
                        {
                          required: false,
                          message: "Select Prefix"
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                        }
                      ]}>
                      <Select showSearch
                        placeholder="Select Prefix">
                        <Option key={0} value={null}>Select Prefix</Option>
                        <Option key={1} value={EmpPrefixEnum.Mr}>{EmpPrefixEnum.Mr}</Option>
                        <Option key={2} value={EmpPrefixEnum.Miss}>{EmpPrefixEnum.Miss}</Option>
                        <Option key={3} value={EmpPrefixEnum.Mrs}>{EmpPrefixEnum.Mrs}</Option>

                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="employeeName"
                      label="Employee Name"
                      rules={[
                        {
                          required: true,
                          message: "Enter Employee Name"
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                          message: `Should contain only alphabets.`
                        }
                      ]}>
                      <Input placeholder='First Name' />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="employeeLastName"
                      label="Last Name"
                      rules={[
                        {
                          required: true,
                          message: "Enter Employee Name"
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                          message: `Should contain only alphabets.`
                        }
                      ]}>
                      <Input placeholder='Last Name' />
                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="designation"
                      label="Designation"
                      rules={[
                        {
                          required: true,
                          message: "Select Designation "
                        },
                      ]}>
                    
                    <Select
                                    placeholder="Select designation"
                                    // onChange={}
                                    allowClear
                                    style={{ width: '100%' }}
                                  >
                                    {designationData.map(dropData => {
                                      return <Option value={dropData.designation}>{dropData.designation}</Option>;
                                    })}</Select>

                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                  <Form.Item
                    name="employeeRole"
                    label="Role"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  ><Select
                    showSearch
                    placeholder="Select Employee Role"
                  >
                      <Option key={0} value={null}>Select Employee Role</Option>
                      {
                        Object.keys(EmployeeRolesEnum).map(function (key, index) {
                          return <Option key={EmployeeRolesEnum[key]} value={EmployeeRolesEnum[key]}>{EmployeeRolesEnum[key]}</Option>
                        })
                      }
                    </Select>
          
                  </Form.Item>
                   </Col>

                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="dateOfBirth"
                      label="Date Of Birth"
                      rules={[
                        {
                          required: false,
                        }
                      ]}>
                      <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" showToday={false} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="gender"
                      label="Gender"
                      rules={[
                        {
                          required: true,
                          message: "Enter a valid Gender",
                          max: 10
                        }
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Gender"
                      >
                        <Option key={0} value={null}>Select Gender</Option>
                        <Option key={1} value={'Male'}>Male</Option>
                        <Option key={2} value={'Female'}>Female</Option>
                      </Select>}
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="maritualStatus"
                      label="Marital Status"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Marital Status  ",
                          max: 10
                        }
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Marital Status"
                      >
                        <Option key={0} value={null}>Select Marital Status</Option>
                        <Option key={1} value={'Married'}>Married</Option>
                        <Option key={2} value={'UnMarried'}>UnMarried </Option>
                      </Select>}
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="mobileNumber"
                      label="Contact Number"
                      rules={[
                        {
                          required: true,
                          message: "Enter a valid contact number",
                          max: 10
                        },
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Should contain only numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={{span:24}} sm={{span:24}} md={{span:5,offset:1}} lg={{span:5,offset:1}} xl={{span:5,offset:1}} style={{margin:'1%'}} >
            <Form.Item
                name="altMobileNumber"
                label=" Alternative Contact Number"
                rules={[
                  {
                    required: false,
                    message: "Enter a valid Alternative contact number",
                    max:10
                  },
                  {
                    pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                    message: `Should contain only numbers.`
                  }
                ]}>
                <Input/>
              </Form.Item>
          </Col> */}


                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="emailID"
                      label="Email Id"
                      rules={[
                        {
                          required: false,
                          type: 'email',
                          message: "Please enter your email Id"
                        },
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="bloodGroup"
                      label="Blood Group"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Blood Group ",
                          max: 10
                        }
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Blood Group"
                      >
                        <Option key={0} value={null}>Select Marital Status</Option>
                        <Option key={1} value={'O+'}>O+</Option>
                        <Option key={2} value={'O-'}>O-</Option>
                        <Option key={3} value={'B+'}>A+</Option>
                        <Option key={4} value={'B-'}>A-</Option>
                        <Option key={5} value={'B+'}>B+</Option>
                        <Option key={6} value={'B-'}>B-</Option>
                        <Option key={7} value={'AB+'}>AB+</Option>
                        <Option key={8} value={'AB-'}>AB-</Option>

                      </Select>}
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="nationality"
                      label="Nationality"
                      rules={[
                        {
                          required: false,
                          message: "Please enter your Nationality"
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                          message: `Should contain only alphabets.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="departmentId"
                      label="Department"

                      rules={[
                        {
                          required: false,
                          message: 'Department is required'
                        },
                      ]}>
                      <Select
                        showSearch
                        placeholder="Select Department"
                        optionFilterProp="children"
                        onChange={onChange}
                        onSearch={onSearch}
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

                      >
                        {departmentsData?.map(dropData => {
                          return <Option key={dropData.deptId} value={dropData.deptId}>{dropData.deptName}</Option>;
                        })}
                      </Select>
                    </Form.Item>

                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="unitId"
                      label="Unit"
                      rules={[
                        {
                          required: false, message: 'Select Unit',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Unit"
                        // onChange={handlePlant}
                        allowClear
                        style={{ width: '100%' }}
                      >
                        {plantData.map(dropData => {
                          return <Option value={dropData.plantId}>{dropData.plantName}</Option>;
                        })}
                      </Select>

                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="priorityOne"
                      label="Priority One"
                      rules={[
                        {
                          required: false,
                          message: "Please enter your Priority One"
                        },

                      ]}>
                         <Select
                showSearch
                placeholder="Select Operation"
                optionFilterProp="children"
                // onChange={handleOperation}
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={0} value={null}>Select Operations</Option>
                {operations.map((workstationCategory) => {
                  return <Option value={workstationCategory.operationId}>{workstationCategory.operationName}</Option>   
                   })}
              </Select>
                    
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="priorityType"
                      label="Priority Two"
                      rules={[
                        {
                          required: false,

                          message: "Please enter your Priority Type"
                        },
                      
                      ]}>
                          <Select
                        showSearch
                        placeholder="Select Operation"
                        optionFilterProp="children"
                        // onChange={handleOperation}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onSearch={onSearch}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        <Option key={0} value={null}>Select Operations</Option>
                        {operations.map((workstationCategory) => {
                          return <Option key={workstationCategory.operationId} value={workstationCategory.operationId}>{workstationCategory.operationName}</Option>
                        })}
                      </Select>
                    
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  {/* <Col xs={{span:10}} sm={{span:10}} md={{span:10}} lg={{span:10}} xl={{span:10}} style={{margin:'5px'}}> */}
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} xl={{ span: 10, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="currentAddress"
                      label="Current Address"
                      rules={[
                        {
                          pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                          message: `Don't Allow Spaces`
                        }
                      ]}>
                      <TextArea rows={4} style={{ width: '100%' }} />

                    </Form.Item>
                  </Col>
                  {/* <Col xs={{span:10}} sm={{span:10}} md={{span:10}} lg={{span:10}} xl={{span:10}}  style={{margin:'1%'}}> */}
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} xl={{ span: 10, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="permanentAddress" label="Permanent address"
                      rules={[
                        {
                          pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                          message: `Don't Allow Spaces`
                        }
                      ]}>
                      <TextArea rows={4} style={{ width: '100%' }} />

                    </Form.Item>
                    <Form.Item name='sameAsCurAddress'>
                      <Checkbox onChange={setAddress} style={{ paddingRight: '250px' }}>Same as Current Address</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Divider />
                <Row gutter={24}>
                  <h1 style={{ color: 'grey', fontSize: '25px', textAlign: 'left' }}>Job Details</h1><br />
                </Row>
                <Row gutter={24}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    
                    <Form.Item
                      name="employeeStatus"
                      label="Employee Status"
                      rules={[
                       
                       
                      ]}>
                         <Select
                        showSearch
                        placeholder="Select Employee Mode"
                      >
                        <Option key={0} value={null}>Select Employee Status</Option>
                        <Option key={1} value={'Direct'}>Full Time</Option>
                        <Option key={2} value={'Refrence'}>Part Time</Option>
                        <Option key={3} value={'Transfer'}>Contract</Option>
                        <Option key={4} value={'Other'}>Intern</Option>
                      </Select>
                    
                    </Form.Item>
                  </Col>
             
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>

                    <Form.Item
                      name="yearsOfExperience"
                      label="Year Of Experience"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Year of experience",
                          max: 10
                        },
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Should contain only numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="companyEmail"
                      label="Company Email"
                      rules={[
                        {
                          required: false,
                          type: 'email',
                          message: "Please enter your Company email"
                        },
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="employeeMode"
                      label="Employee Mode"
                      rules={[
                        {
                          required: false,
                          message: "Enter valid employee mode"
                        }
                      ]}>
                      {/* <Select
              showSearch
              placeholder="Select Employee Role"
                >
                  <Option key={0} value={null}>Select Employee Role</Option>
                  <Option key={1} value= {'Manager'}>Manager</Option>
                  <Option key={2} value= {'Sales'}>Sales</Option>
                  <Option key={3} value= {'Executive'}>Executive</Option>
                  <Option key={4} value= {'Operator'}>Operator</Option>
              </Select> */}
                      <Select
                        showSearch
                        placeholder="Select Employee Mode"
                      >
                        <Option key={0} value={null}>Select Employee Mode</Option>
                        <Option key={1} value={'Direct'}>Direct</Option>
                        <Option key={2} value={'Refrence'}>Refrence</Option>
                        <Option key={3} value={'Transfer'}>Transfer</Option>
                        <Option key={4} value={'Other'}>Other</Option>
                      </Select>

                    </Form.Item>
                  </Col>
                  {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="employeeStatus"
                      label="Employee Status"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Employee status",
                        }
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Employee status "
                      >
                        <Option key={0} value={null}>Select Employee status </Option>
                        <Option key={1} value={'Active'}>Active </Option>
                        <Option key={2} value={'In Active'}>In Active </Option>
                      </Select>}
                    </Form.Item>
                  </Col> */}
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="dateOfJoin"
                      label="Date Of Joining"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Date of joining",
                        }
                      ]}>
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="dateOfleave"
                      label="Date Of Leaving"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Date of leaving",
                        }
                      ]}>
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col> */}
                  {(props.isUpdate === true) &&
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            
                    <Form.Item
                      name="workstationNumber"
                      label="Workstation Number"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Workstation number",
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>}
                  {(props.isUpdate === true) &&
                   <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}> 
        
                    <Form.Item
                    
                      name="healthCardNumber"
                      label="Health Card Number"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Health card number",
                        },
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Should contain only numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>}
                  {(props.isUpdate === true) &&
                   <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}> 
              
                    <Form.Item
                      name="uanNumber"
                      label="UAN Number"
                      rules={[
                        // {
                        //   required: false,
                        //   message: "Enter a valid UAN number",
                        // },
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Should contain only numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col> }
                  {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="salary"
                      label="Salary"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Salary",
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col> */}
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="bankAccountNumber"
                      label="Bank Accout Number"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Bank accout number",
                          max: 16
                        },
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Should contain only numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="ifscCode"
                      label="IFSC Code"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid IF SC Code",
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="designation"
                      label="Designation"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Designation",
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col> */}
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="dateOfEntry"
                      label="Date Of Entry"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Date of entry",
                        }
                      ]}>
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="emergencyContactNo"
                      label="Emergency Contact Number"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid contact number",
                          max: 10
                        },
                        {
                          pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                          message: `Should contain only numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="emergencyContactName"
                      label="Emergency Contact Name"
                      rules={[
                        {
                          required: false,
                          message: "This field is mandatory"
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                          message: `Should contain only alphabets.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col> */}
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="isProbPeriodCompleted"
                      label="Is Probhitionary Period Completed"
                      rules={[
                        {
                          required: false,
                          message: "This field is mandatory"
                        },
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Probhition Period"
                      >
                        <Option key={0} value={null}>Select Probhition Period</Option>
                        <Option key={1} value={'Yes'}>Yes</Option>
                        <Option key={2} value={'No'}>No </Option>
                      </Select>}
                    </Form.Item>


                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} xl={{ span: 10, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="skillSet"
                      label="Skill Set"
                      rules={[
                        {
                          pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                          message: `Don't Allow Spaces`
                        },
                        // {
                        //   required:false,
                        //   message:'This is a mandatory field'
                        // }
                      ]}
                    >
                      <TextArea rows={4} style={{ width: '100%' }} />
                      <br />

                    </Form.Item>
                  </Col>
                </Row>
                <Divider />
                <Row gutter={24}>
                  <h1 style={{ color: 'grey', fontSize: '25px', textAlign: 'left' }}>Family Details</h1><br />
                </Row>
                <Row gutter={24}>
                  <Form.List name="familyDetails">
                    {(fields, { add, remove }) => (
                      <Card>
                        <Form.Item>
                          <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Add Family Details
                          </Button>
                        </Form.Item>
                        {fields.map(field => (
                          <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }}>
                            <Form.Item name={[field.name, 'employeeFamilyId']} fieldKey={[field.fieldKey, 'employeeFamilyId']}>
                              <Input hidden />
                            </Form.Item>
                            <Row gutter={24}>
                              <Col span={6}>
                                <Form.Item {...field} label="Name" name={[field.name, 'familyMemName']} fieldKey={[field.fieldKey, 'familyMemName']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing familyMemName'
                                    },
                                    {
                                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                      message: `Should contain only alphabets.`
                                    }
                                  ]}
                                >
                                  <Input onChange={familyDetailsAffix} />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="Relation" name={[field.name, 'relation']} fieldKey={[field.fieldKey, 'relation']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing relation'
                                    },
                                    {
                                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                      message: `Should contain only alphabets.`
                                    }
                                  ]}
                                >

                                  {<Select
                                    showSearch
                                    placeholder="Select  Relation"
                                  >
                                    <Option key={0} value={null}>Select Relation</Option>
                                    <Option key={1} value={'Father'}>Father</Option>
                                    <Option key={2} value={'Mother '}>Mother </Option>
                                    <Option key={3} value={'Husband'}>Husband</Option>
                                    <Option key={4} value={'Daughter'}>Daughter </Option>
                                    <Option key={5} value={'Son'}>Son</Option>
                                  </Select>}
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item label="Date Of Birth" name={[field.name, 'famDateOfBirth']} fieldKey={[field.fieldKey, 'famDateOfBirth']} rules={[{ required: false, message: 'Missing Date ' }]}>
                                  <DatePicker style={{ width: '100%' }} />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="Aadhar Number" name={[field.name, 'famAadharNo']} fieldKey={[field.fieldKey, 'famAadharNo']}
                                  rules={[{
                                    required: false,
                                    message: "Enter a valid Aadhar card number",
                                    max: 12
                                  },
                                  {
                                    pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                                    message: `Should contain only numbers.`
                                  }]}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                            </Row>
                            <MinusCircleOutlined onClick={() => remove(field.name)} />
                          </Space>
                        ))}
                      </Card>


                    )}
                  </Form.List>
                </Row>
                <Divider />
                <Row gutter={24}>
                  <h1 style={{ color: 'grey', fontSize: '25px', textAlign: 'left' }}>Educational Details</h1><br />
                </Row>
                <Row gutter={24}>
                  <Form.List name="educationDetails">
                    {(fields, { add, remove }) => (
                      <Card>
                        <Form.Item>
                          <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Add Educational Details
                          </Button>
                        </Form.Item>
                        {fields.map(field => (
                          <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }}>
                            <Form.Item name={[field.name, 'employeeEducationId']} fieldKey={[field.fieldKey, 'employeeEducationId']}>
                              <Input hidden />
                            </Form.Item>
                            <Row gutter={24}>
                              <Col span={6}>
                                <Form.Item {...field} label="Qualification" name={[field.name, 'empQualification']} fieldKey={[field.fieldKey, 'empQualification']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing Qualification'
                                    },
                                    {
                                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                      message: `Should contain only alphabets.`
                                    }
                                  ]}
                                >
                                  <Select
                                    placeholder="Select qualification"
                                    // onChange={}
                                    allowClear
                                    style={{ width: '100%' }}
                                  >
                                    {qualificationData.map(dropData => {
                                      return <Option value={dropData.qualificationName}>{dropData.qualificationName}</Option>;
                                    })}</Select>

                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="Specialization" name={[field.name, 'Specialization']} fieldKey={[field.fieldKey, 'Specialization']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing Specialization'
                                    },
                                    {
                                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                      message: `Should contain only alphabets.`
                                    }
                                  ]}
                                >
                                  <Input onChange={educationDetailsAffix} />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item label="Date Of Passout" name={[field.name, 'famDateOfPassout']} fieldKey={[field.fieldKey, 'famDateOfPassout']} rules={[{ required: false, message: 'Missing Date ' }]}>
                                  <DatePicker style={{ width: '100%' }} />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="Percentage/CGPA" name={[field.name, 'percentage']} fieldKey={[field.fieldKey, 'percentage']}
                                  rules={[{
                                    required: false,
                                    message: "Enter a valid percentage/CGPA",
                                    max: 12
                                  },
                                 ]}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                            </Row>
                            <MinusCircleOutlined onClick={() => remove(field.name)} />
                          </Space>
                        ))}
                      </Card>


                    )}
                  </Form.List>
                </Row>
                <Divider />

                <Row gutter={24}>
                  <h1 style={{ color: 'grey', fontSize: '25px', textAlign: 'left' }}>ID Proof Details</h1><br />
                </Row>
                <Row gutter={24}>
                  <Form.List name="idProofDetails">
                    {(fields, { add, remove }) => (
                      <Card>
                        <Form.Item>
                          <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Add ID Proof Details
                          </Button>
                        </Form.Item>
                        {fields.map(field => (
                          <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }}>
                            <Form.Item name={[field.name, 'employeeIdProofId']} fieldKey={[field.fieldKey, 'employeeIdProofId']}>
                              <Input hidden />
                            </Form.Item>
                            <Row gutter={40}>
                              <Col span={12}>
                                <Form.Item {...field} label="ID Type" name={[field.name, 'idType']} fieldKey={[field.fieldKey, 'idType']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing ID Type'
                                    },
                                    {
                                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                      message: `Should contain only alphabets.`
                                    }
                                  ]}>
                                  <Select showSearch
                                    placeholder="Select ID Type">
                                    <Option key={0} value={null}>Select ID Type</Option>
                                    <Option key={1} value={'Yes'}>Aadhar Card</Option>
                                    <Option key={2} value={'No'}>Pan Card </Option>
                                    <Option key={3} value={'No'}>Driving Licence</Option>


                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item {...field} label="ID Number" name={[field.name, 'idNumber']} fieldKey={[field.fieldKey, 'idnumber']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing ID Number'
                                    },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                            </Row>
                            <MinusCircleOutlined onClick={() => remove(field.name)} />
                          </Space>
                        ))}
                      </Card>


                    )}
                  </Form.List>
                </Row>
                <Divider />

                <Row gutter={24}>
                  <h1 style={{ color: 'grey', fontSize: '25px', textAlign: 'left' }}>Experience Details</h1><br />
                </Row>
                <Row gutter={24}>
                  <Form.List name="experienceDetails">
                    {(fields, { add, remove }) => (
                      <Card>
                        <Form.Item>
                          <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Add Experience Details
                          </Button>
                        </Form.Item>
                        {fields.map(field => (
                          <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }}>
                            <Form.Item name={[field.name, 'employeeExperienceId']} fieldKey={[field.fieldKey, 'employeeExperienceId']}>
                              <Input hidden />
                            </Form.Item>
                            <Row gutter={24}>
                              <Col span={6}>
                                <Form.Item {...field} label="Organization" name={[field.name, 'organisation']} fieldKey={[field.fieldKey, 'organisation']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing Organization'
                                    },
                                    {
                                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                      message: `Should contain only alphabets.`
                                    }
                                  ]}
                                >
                                  <Input onChange={experienceDetailsAffix} />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="Designation" name={[field.name, 'Designation']} fieldKey={[field.fieldKey, 'Designation']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing Designation'
                                    },
                                    {
                                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                      message: `Should contain only alphabets.`
                                    }
                                  ]}
                                  
                                >
                    <Input />
                                
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="From Date" name={[field.name, 'fromDate']} fieldKey={[field.fieldKey, 'fromDate']} rules={[{ required: false, message: 'Missing Date ' }]}>
                                  <DatePicker
                                    style={{ width: '100%' }}
                                    onChange={() => setautoRefresh(prev => prev + 1)} />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="To Date" name={[field.name, 'toDate']} fieldKey={[field.fieldKey, 'toDate']} rules={[{ required: false, message: 'Missing Date ' }]}>
                                  <DatePicker
                                    style={{ width: '100%' }}
                                    onChange={() => setautoRefresh(prev => prev + 1)} />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item {...field} label="Experience" name={[field.name, 'experience']} fieldKey={[field.fieldKey, 'familyMemName']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Missing Experience'
                                    },
                                   
                                  ]}
                                >
                                  <Input onChange={familyDetailsAffix} />
                                </Form.Item>
                              </Col>
                              {/* <Col span={6}>
                                <Form.Item {...field}
                                  initialValue={experienceCalculation(form.getFieldValue('fromDate'), form.getFieldValue('toDate'))}
                                  label="Experience" name={[field.name, 'experience']} fieldKey={[field.fieldKey, 'experience']}
                                >
                                  
                                  <Input />
                                </Form.Item>
                              </Col> */}
                            </Row>
                            <MinusCircleOutlined onClick={() => remove(field.name)} />
                          </Space>
                        ))}
                      </Card>


                    )}
                  </Form.List>
                </Row>
                <Divider />

                <Row>
                  <Col span={24} style={{ textAlign: 'right' }}>

                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                    {(props.isUpdate === false) &&
                      <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                        Reset
                      </Button>}
                  </Col>


                </Row>


               </>:<></>}

                {laboursEmployeeVisible ?
<>

                  <Row>

                    
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="employeeCode"
                      label="Employee Code"
                      rules={[
                        {
                          required: true,
                          message: "Enter Employee code"
                        },
                        {
                          // pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z0-9 ]*$/,
                          pattern: /^[^-\s\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z0-9 ]*$/,
                          message: `Should contain only alphabets and numbers.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
               



                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ margin: '1%' }}>
                      <Form.Item
                        name="employeeName"
                        label=" Employee Name"
                        rules={[
                          {
                            required: true,
                            message: "Enter Your Name"
                          },
                          {
                            pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z ]*$/,
                            message: `Should contain only alphabets.`
                          },
                        ]}>

                        <Input />
                      </Form.Item>
                    </Col>


                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ margin: '1%' }}>
                      <Form.Item
                        name="employeeLastName"
                        label="Last Name"
                        rules={[
                          {
                            required: true,
                            message: "Enter Your  Last Name"
                          },
                          {
                            pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z ]*$/,
                            message: `Should contain only alphabets.`
                          },
                        ]}>

                        <Input />
                      </Form.Item>
                    </Col>


                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ margin: '1%' }}>
                      <Form.Item
                        name="famAadharNo"
                        label="Adhaar Number"
                        rules={[
                          {
                            required: true,
                            message: "Enter a valid Adhaar Number",
                            max: 12
                          },
                          {
                            pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                            message: `Should contain only numbers.`
                          }
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ margin: '1%' }}>
                      <Form.Item
                        name="mobileNumber"
                        label="Mobile Phone"
                        rules={[
                          {
                            required: true,
                            message: "Enter a valid contact number",
                            max: 10
                          },
                          {
                            pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                            message: `Should contain only numbers.`
                          }
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="dateOfBirth"
                      label="Date Of Birth"
                      rules={[
                        {
                          required: false,
                        }
                      ]}>
                      <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" showToday={false} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="gender"
                      label="Gender"
                      rules={[
                        {
                          required: true,
                          message: "Enter a valid Gender",
                          max: 10
                        }
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Gender"
                      >
                        <Option key={0} value={null}>Select Gender</Option>
                        <Option key={1} value={'Male'}>Male</Option>
                        <Option key={2} value={'Female'}>Female</Option>
                      </Select>}
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="maritualStatus"
                      label="Marital Status"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Marital Status  ",
                          max: 10
                        }
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Marital Status"
                      >
                        <Option key={0} value={null}>Select Marital Status</Option>
                        <Option key={1} value={'Married'}>Married</Option>
                        <Option key={2} value={'UnMarried'}>UnMarried </Option>
                      </Select>}
                    </Form.Item>
                  </Col>
                  
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="emailID"
                      label="Email Id"
                      rules={[
                        {
                          required: false,
                          type: 'email',
                          message: "Please enter your email Id"
                        },
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="bloodGroup"
                      label="Blood Group"
                      rules={[
                        {
                          required: false,
                          message: "Enter a valid Blood Group ",
                          max: 10
                        }
                      ]}>
                      {<Select
                        showSearch
                        placeholder="Select Blood Group"
                      >
                        <Option key={0} value={null}>Select Marital Status</Option>
                        <Option key={1} value={'O+'}>O+</Option>
                        <Option key={2} value={'O-'}>O-</Option>
                        <Option key={3} value={'B+'}>A+</Option>
                        <Option key={4} value={'B-'}>A-</Option>
                        <Option key={5} value={'B+'}>B+</Option>
                        <Option key={6} value={'B-'}>B-</Option>
                        <Option key={7} value={'AB+'}>AB+</Option>
                        <Option key={8} value={'AB-'}>AB-</Option>

                      </Select>}
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="nationality"
                      label="Nationality"
                      rules={[
                        {
                          required: false,
                          message: "Please enter your Nationality"
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                          message: `Should contain only alphabets.`
                        }
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="departmentId"
                      label="Department"

                      rules={[
                        {
                          required: false,
                          message: 'Department is required'
                        },
                      ]}>
                      <Select
                        showSearch
                        placeholder="Select Department"
                        optionFilterProp="children"
                        onChange={onChange}
                        onSearch={onSearch}
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

                      >
                        {departmentsData?.map(dropData => {
                          return <Option key={dropData.deptId} value={dropData.deptId}>{dropData.deptName}</Option>;
                        })}
                      </Select>
                    </Form.Item>

                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="unitId"
                      label="Unit"
                      rules={[
                        {
                          required: false, message: 'Select Unit',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Unit"
                        // onChange={handlePlant}
                        allowClear
                        style={{ width: '100%' }}
                      >
                        {plantData.map(dropData => {
                          return <Option value={dropData.plantId}>{dropData.plantName}</Option>;
                        })}
                      </Select>

                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="priorityOne"
                      label="Priority One"
                      rules={[
                        {
                          required: false,
                          message: "Please enter your Priority One"
                        },
                      ]}>
                         <Select
                showSearch
                placeholder="Select Operation"
                optionFilterProp="children"
                // onChange={handleOperation}
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={0} value={null}>Select Operations</Option>
                {operations.map((workstationCategory) => {
                  return <Option key={workstationCategory.operationId} value={workstationCategory.operationId}>{workstationCategory.operationName}</Option>
                })}
              </Select>
                     
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
                    <Form.Item
                      name="priorityType"
                      label="Priority Two"
                      rules={[
                        {
                          required: false,

                          message: "Please enter your Priority Type"
                        },
                      ]}>
                        <Select
                showSearch
                placeholder="Select Operation"
                optionFilterProp="children"
                // onChange={handleOperation}
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={0} value={null}>Select Operations</Option>
                {operations.map((workstationCategory) => {
                  return <Option key={workstationCategory.operationId} value={workstationCategory.operationId}>{workstationCategory.operationName}</Option>
                })}
              </Select>
                    </Form.Item>
                  </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} xl={{ span: 10, offset: 1 }} style={{ margin: '1%' }}>
                      <Form.Item
                        name="currentAddress"
                        label="Address"
                        rules={[
                          {
                            pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                            message: `Don't Allow Spaces`
                          },
                          // {
                          //   required:false,
                          //   message:'This is a mandatory field'
                          // }
                        ]}
                      >
                        <TextArea rows={4} style={{ width: '100%' }} />
                        <br />

                      </Form.Item>
                    </Col>
                    </Row>
                    <Row>
                      <Col span={40} style={{ textAlign: 'right' }}>

                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                        {(props.isUpdate === false) &&
                          <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                            Reset
                          </Button>}
                      </Col>


                    

                  </Row>

                  </>:<></>}



    </Form>
    </Card>
  )
}

export default HrmsEmployeeDetailsForm;
